<template>
    <div>
        <!-- 发件箱 -->
        <div style="display: flex;justify-content: space-between;align-items: center;">
            <h3>{{ $t('lang.smartsms.overview') }}</h3>
            <el-button size="mini" @click="refesh" type="primary">刷新</el-button>
        </div>
        <div class="storage_stuts">
            {{ $t('lang.smartsms.storeState') }}: {{ used }} / {{ total }}
        </div>
        <el-divider></el-divider>
        <el-button size="mini" type="primary" @click="addOutMessage">添加短信</el-button>
        <!-- 水平线 -->
        <el-divider></el-divider>
        <h3>{{ $t('lang.smartsms.messageList') }}</h3>
        <el-table :data="showList">
            <el-table-column :label="$t('lang.smartsms.serialNumber')" prop="index" width="80"></el-table-column>
            <el-table-column :label="$t('lang.smartsms.telephoneNumber')" prop="phone" width="160"></el-table-column>
            <el-table-column :label="$t('lang.smartsms.SMSContent')" prop="content"></el-table-column>
            <el-table-column :label="$t('lang.smartsms.state')" prop="state" width="80">
                <template slot-scope="scope">
                    {{ stateFilter(scope.row.state) }}
                    <!-- 索引 -->
                </template>
            </el-table-column>
            <el-table-column label="操作" width="210">
                <template slot-scope="scope">
                    <el-button size="mini" type="warning" @click="openEditDialog(scope.row)">{{ $t('lang.smartsms.edit')
                    }}</el-button>
                    <el-button size="mini" @click="sendSelectSms(scope.row.index, scope.row.meta_index)" type="primary">{{
                        $t('lang.smartsms.send')
                    }}</el-button>
                    <el-button size="mini" type="danger" @click="deleteOutboxMsg(scope.row.index, scope.row.meta_index)">{{
                        $t('lang.smartsms.delete') }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination :page-sizes="[5, 10, 25, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next"
                :total="list.length" :current-page="currentPage" @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <el-dialog :title="$t('lang.smartsms.edit')" :visible.sync="editMsgDialog" width="50%">
            <el-form label-width="100px" :model="editForm" :rules="editFormRules">
                <el-form-item :label="$t('lang.smartsms.telephoneNumber')" prop="phone">
                    <el-input size="mini" class="input" v-model="editForm.phone"></el-input>
                    <p class="tips">{{ $t('lang.smartsms.tips1') }}</p>
                </el-form-item>
                <el-form-item :label="$t('lang.smartsms.SMSContent')" prop="content">
                    <el-input type="textarea" v-model="editForm.content"></el-input>
                    <p class="tips">{{ $t('lang.smartsms.tips3') }}</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="saveAsDraft">{{ $t('lang.smartsms.saveAsDraft') }}</el-button>
                <el-button size="mini" type="primary" @click="sendSms">{{ $t('lang.smartsms.sendImmediately')
                }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        // 表单检查，内容不可以超过1500字节
        let checkContent = (rule, value, callback) => {
            if (value.length > 1500) {
                callback(new Error(this.$t('lang.smartsms.tips2')));
            } else {
                callback();
            }
        };
        return {
            used: "",
            total: "",
            list: [],
            editMsgDialog: false,
            editForm: {
                index: "",
                phone: "",
                content: "",
                meta_index: ""
            },
            pageSize: 10,
            currentPage: 1,
            editFormRules: {
                phone: [{
                    required: true,
                    message: this.$t('lang.smartsms.tips1'),
                    trigger: 'blur'
                }],
                content: [{
                    required: true,
                    message: "不可以为空",
                    trigger: 'blur'
                },{
                    validator: checkContent,
                    trigger: 'blur'
                }]
            }
        };
    },
    computed: {
        // 状态过滤器
        stateFilter() {
            return function (state) {
                switch (state) {
                    case '4':
                        return this.$t('lang.smartsms.FailedToSend');
                    case '3':
                        return this.$t('lang.smartsms.SentSuccessfully');
                    case '2':
                        return this.$t('lang.smartsms.sending');
                    case '5':
                        return this.$t('lang.smartsms.draft');
                    default:
                        return "未知状态";
                }
            }
        },
        showList() {
            let start = (this.currentPage - 1) * this.pageSize;
            let end = this.currentPage * this.pageSize;
            return this.list.slice(start, end);
        }
    },
    methods: {
        openEditDialog(e) {
            this.editForm.phone = e.phone;
            this.editForm.content = e.content;
            this.editForm.index = e.index;
            this.editForm.meta_index = e.meta_index;
            this.editMsgDialog = true;
        },
        saveAsDraft() {
            this.$emit('saveAsDraft', {
                index: this.editForm.index,
                phone: this.editForm.phone,
                content: this.editForm.content,
                state: '5',
                addIndex: this.list.length,
                meta_index: this.editForm.index
            })
        },
        deleteOutboxMsg(index, iindex) {
            console.log(index, iindex);
            // 确认框
            this.$confirm(this.$t('lang.smartsms.tips2'), this.$t('lang.smartsms.tips'), {
                confirmButtonText: this.$t('lang.smartsms.sure'),
                cancelButtonText: this.$t('lang.smartsms.cancel'),
                type: 'warning'
            }).then(() => {
                // 删除
                this.$emit('deleteOutboxMsg', {
                    index: index,
                    iindex: iindex
                })
            }).catch(() => {
            });
        },
        addOutMessage() {
            this.editForm = {
                index: "",
                phone: "",
                content: "",
            }
            this.editMsgDialog = true;
        },
        sendSms() {
            this.$emit('saveAsDraft', {
                index: this.editForm.index,
                phone: this.editForm.phone,
                content: this.editForm.content,
                state: '2',
                addIndex: this.list.length,
                meta_index: this.editForm.index
            })
        },
        sendSelectSms(index, iindex) {
            this.$emit("sendSelectSms", {
                index: index,
                iindex: iindex
            })
        },
        refesh() {
            this.$emit('refesh')
        },
        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    },
};
</script>
<style scoped>
h3 {
    font-size: 16px;
}

.storage_stuts {
    text-align: center;
}

.input {
    width: 320px;
}

.tips {
    color: #999;
    font-size: 12px;
}

.pagination {
    margin-top: 1rem;
}
</style>